/* eslint-disable no-underscore-dangle */
import Modal from 'antd/lib/modal/Modal';
import KPageHeader from 'common/component/KPageHeader';
import KProTip from 'common/component/KProTip';
import KSpinner from 'common/component/KSpinner';
import { BiSupport } from 'react-icons/bi';
import { SystemUserWrapper } from 'features/users/view/user.style';

import React from 'react';
import { useSelector } from 'react-redux';
import { RootState } from 'redux/store';
import styled from 'styled-components';
import Editor from '../components/Editor';
import { useSupport } from '../hooks/useSupport';

const support_cats = ['Not Replied', 'Replied'];

export default function SupportView(): JSX.Element {
  const [selectedCat, setSelectedCat] = React.useState('Not Replied');
  const [modalVisible, setModalVisible] = React.useState(false);
  const [selectedId, setSelectedId] = React.useState('');
  const [isSubmittedActionCalled, setIsSubmittedActionCalled] = React.useState(false);
  const [reply, setReply] = React.useState('');
  const [replies, setReplies] = React.useState([]);

  const supportQueries = useSelector((state: RootState) => state.support);

  const { fetchSupport, postReply } = useSupport();

  React.useEffect(() => {
    fetchSupport();
  }, []);

  //   const supportQueriesNotReplied = supportQueries.data.filter(
  // (supportQuery) => supportQuery.__replies__.length === 0,
  //   );

  //   const supportQueriesReplied = supportQueries.data.filter(
  //     (supportQuery) => supportQuery.__replies__.length !== 0,
  //   );
  //   if (supportQueries.status === 'data') {
  //     console.log(supportQueries);
  //   }

  const handleOpenReplyModal = (id: string, repliesPara: any = null): void => {
    setSelectedId(id);
    console.log(repliesPara);
    if (repliesPara) {
      setReplies(repliesPara);
    }
    setModalVisible(true);
  };

  const handleEditorChange = (e: any) => {
    setReply(e.target.value);
  };

  const handleReplySubmit = () => {
    postReply(selectedId, reply);
    fetchSupport();
    setIsSubmittedActionCalled(true);
  };
  const handleModalClose = () => {
    setModalVisible(false);
    setReply('');
    setSelectedId('');
    setReplies([]);
    if (isSubmittedActionCalled) {
      fetchSupport();
    }
    setIsSubmittedActionCalled(false);
  };
  console.log('running');
  return (
    <>
      <SystemUserWrapper>
        <KPageHeader title="Support" rightButtonTitle="Create New" onRightButtonClick={() => {}} />

        <KProTip
          title="Page Hint"
          description="This page is for viewing and managing attendance of students & staffs"
        />

        <section className="page-tabs">
          {support_cats.map((item, index) => (
            <div
              key={index}
              onClick={(): void => {
                setSelectedCat(item);
              }}
              className={`page-tabs-item ${item === selectedCat ? 'active' : ''}`}
            >
              {item}
            </div>
          ))}
        </section>

        <SupportQueryWrapper>
          {supportQueries.status === 'loading' && (
            <SpinnerWrapper>
              <KSpinner />
            </SpinnerWrapper>
          )}
          {supportQueries.status === 'data' &&
            selectedCat === 'Replied' &&
            supportQueries.data.replied.map((supportQuery) => (
              <SupportQuery
                key={supportQuery.id}
                onClick={() => handleOpenReplyModal(supportQuery.id, supportQuery.__replies__)}
              >
                <div className="query-title">{supportQuery.subject}</div>
                <div className="query-desc">{supportQuery.description}</div>
              </SupportQuery>
            ))}
          {supportQueries.status === 'data' &&
            selectedCat === 'Not Replied' &&
            supportQueries.data.notReplied.map((supportQuery) => (
              <SupportQuery
                key={supportQuery.id}
                onClick={() => handleOpenReplyModal(supportQuery.id)}
              >
                <div className="query-title">{supportQuery.subject}</div>
                <div className="query-desc">{supportQuery.description}</div>
              </SupportQuery>
            ))}

          <Modal
            title="Make A Reply"
            centered
            visible={modalVisible}
            onOk={handleModalClose}
            onCancel={handleModalClose}
          >
            {replies.map((reply: any, i: number) => {
              return (
                <ReplyWrapper key={`reply${i}`}>
                  <span>
                    <BiSupport />
                  </span>
                  {reply.description}
                </ReplyWrapper>
              );
            })}
            <Editor onChange={handleEditorChange} onSubmit={handleReplySubmit} value={reply} />
          </Modal>
        </SupportQueryWrapper>
      </SystemUserWrapper>
    </>
  );
}

const ReplyWrapper = styled.div`
  padding: 10px 20px;
  font-size: 1.3em;
  margin: 20px 10px;
  border-radius: 30px;
  border-top-left-radius: 0px;
  border-top-right-radius: 20px;
  border-bottom-left-radius: 50px;
  color: white;
  background: #00315d;
  span {
    padding-right: 10px;
  }
  /* box-shadow: 20px 20px 60px #bebebe, -20px -20px 60px #ffffff; */
`;

const SpinnerWrapper = styled.div`
  width: 80%;
  display: flex;
  justify-content: center;
`;

const SupportQueryWrapper = styled.div`
  display: flex;
  flex-wrap: wrap;
`;

const SupportQuery = styled.div`
  display: inline-block;
  background: #ffffff;
  /* width: 640px; */
  height: 91px;
  border: 1px solid #e0e0e0;
  border-radius: 10px;
  padding: 10px;
  margin: 1em;
  .query-title {
    font-size: var(--font-md);
    font-weight: bold;
    color: var(--text-grey);
    padding: '10px';
  }
  .query-desc {
    margin-top: 10px;
    font-size: var(--font-base);
    font-weight: 500;
    color: var(--text-label);
  }
  cursor: pointer;
`;
